export default [
  {
    label: "Item Code",
    name: "itemCode",
    type: "text",
    required: true,
  },
  {
    label: "Category",
    name: "category",
    type: "select",
    options: ["Mask", "Tube", "Filter", "Other"],
    required: true,
  },
  {
    label: "Item Name",
    name: "itemName",
    type: "text",
    required: true,
  },
  {
    label: "Brand",
    name: "brand",
    type: "select",
    options: [
      "ResMed",
      "Wellell",
      "Philips",
      "VentMed",
      "Topson",
      "BMC",
      "Yuwell",
      "Apex",
      "Other",
    ],
  },
  {
    label: "Catalog Order",
    name: "catalogOrder",
    type: "number",
    min: 1,
    step: 1,
    placeholder: "e.g. 125",
    description: "Optional. Leave blank for a regular item.",
  },
  {
    label: "Model",
    name: "model",
    type: "text",
  },
  {
    label: "Size",
    name: "size",
    type: "select",
    options: ["XS", "S", "M", "L", "XL", "Free Size", "Universal", "N/A"],
  },
  {
    label: "Unit Price",
    name: "unitPrice",
    type: "text",
  },
  {
    label: "Stock Quantity",
    name: "stockQuantity",
    type: "text",
    required: true,
  },
  {
    label: "Minimum Stock",
    name: "minimumStock",
    type: "text",
  },
  {
    label: "Vendor",
    name: "vendor",
    type: "select",
    options: [
      "Skyline Medical",
      "SaintMed",
      "BluePoint",
      "Devers Health",
      "3N",
      "Fondooz",
      "MIC",
      "Other",
    ],
  },
  {
    label: "Lot No.",
    name: "lotNo",
    type: "text",
  },
  {
    label: "Incoming Date",
    name: "incomingDate",
    type: "date",
  },
  {
    label: "Expiry Date",
    name: "expiryDate",
    type: "date",
  },
  {
    label: "Location",
    name: "location",
    type: "text",
    description: "Storage location (e.g., Shelf A1, Room 2, etc.)",
  },
  {
    label: "Status",
    name: "status",
    type: "select",
    options: ["Active", "Discontinued", "Out of Stock"],
  },
  {
    label: "Note",
    name: "note",
    type: "textarea",
  },
];
